document.addEventListener('DOMContentLoaded', function() {
  const modelsLists = document.querySelectorAll('.models_item');
  modelsLists.forEach(list => {
    const inputor = list.querySelector('input');
    const modelArr = list.querySelectorAll('.models_item-link');
    list.addEventListener('keyup', function() {
      let val = inputor.value;
      modelArr.forEach(model => {
        model.innerHTML = model.getAttribute('data-model');
        model.classList.add('hidden');
        let modelVal = model.getAttribute('data-model');
        var regex = new RegExp(val, "i");
        if (modelVal.match(regex)) {          
          model.innerHTML = modelVal.replace(regex, '<b>$&</b>');
          model.classList.remove('hidden');
        }
      })
    })
  })
});
